import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Input } from "@/components/ui/inputForm";
import { Button } from "@/components/ui/button";
import { message, ConfigProvider, theme as antdTheme, Checkbox } from "antd";
import { getCategoriaProdutoById, saveCategoriaProduto } from "@/services/categoriaProduto";
import { errorHandler } from "@/utils/errorhandler";

const defaultValues = {
  nome: "",
  controleEntregas: false,
  ativo: true,
};

export default function CadastroCategoriaProduto() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues,
    mode: "onBlur",
  });

  useEffect(() => {
    const carregar = async () => {
      if (!isEdit || !id) {
        reset(defaultValues);
        return;
      }
      try {
        const response = await getCategoriaProdutoById(id);
        if (response.status === 200) {
          const categoria = response.data;
          reset({
            ...defaultValues,
            nome: categoria.nome ?? "",
            controleEntregas: !!categoria.controleEntregas,
            ativo: categoria.ativo !== undefined ? categoria.ativo : true,
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    };
    carregar();
  }, [id, isEdit, reset]);

  const onSubmit = async (data: any) => {
    try {
      const payload = {
        id: id || undefined,
        nome: data.nome,
        controleEntregas: !!data.controleEntregas,
        ativo: !!data.ativo,
      };
      const response = await saveCategoriaProduto(payload);
      if (response.status === 200 || response.status === 201) {
        message.success("Categoria salva com sucesso!");
        navigate("/categoria-produto");
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-8">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-8">
          <span className="text-white text-2xl">
            {isEdit ? "Editar Categoria de Produto" : "Cadastro de Categoria de Produto"}
          </span>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div className="flex items-center mt-6 col-span-2">
            <ConfigProvider theme={{ algorithm: [antdTheme.darkAlgorithm] }}>
              <Checkbox
                id="ativo"
                checked={watch("ativo")}
                onChange={(e) => setValue("ativo", e.target.checked, { shouldValidate: true })}
              >
                <label htmlFor="ativo" className="text-white ml-2">Ativo</label>
              </Checkbox>
            </ConfigProvider>
          </div>
          <div className="col-span-2">
            <label>Nome *</label>
            <Input
              type="text"
              placeholder="Nome"
              maxLength={100}
              {...register("nome", {
                required: "Nome é obrigatório",
                maxLength: { value: 100, message: "O nome deve ter no máximo 100 caracteres" },
              })}
            />
            {errors.nome && <span className="text-red-600">{errors.nome.message}</span>}
          </div>
          <div className="flex items-center col-span-2">
            <ConfigProvider theme={{ algorithm: [antdTheme.darkAlgorithm] }}>
              <Checkbox
                id="controleEntregas"
                checked={watch("controleEntregas")}
                onChange={(e) =>
                  setValue("controleEntregas", e.target.checked, { shouldValidate: true })
                }
              >
                <label htmlFor="controleEntregas" className="text-white ml-2">
                  Controle de Entregas
                </label>
              </Checkbox>
            </ConfigProvider>
          </div>
        </div>
        <div className="flex justify-start p-2 mt-12 gap-8">
          <Button
            className="flex gap-2"
            variant="destructive"
            type="button"
            onClick={() => navigate("/categoria-produto")}
          >
            Cancelar
          </Button>
          <Button className="flex gap-2" type="submit">
            Salvar
          </Button>
        </div>
      </form>
    </div>
  );
}
